import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimUploadPriceFilesForWorkOrderChangeMutationVariables } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimUploadPriceFilesForWorkOrderChangeGql } from '../BimWorkOrderChangeUploadPricesQueries';

export const useUploadBimWorkOrderChangeFiles = () => {
    const dispatch = useDispatch();

    const [data, status, error, request, , abort] = useRequest({
        requestId: 'bimWorkOrderChangeUploadPriceFiles',
        query: bimUploadPriceFilesForWorkOrderChangeGql,
        variables: undefined,
        withEffect: false,
    });

    const [bimUploadPriceFilesReset] = useResetStoreData({ requestId: 'bimWorkOrderChangeUploadPriceFiles' });

    const bimUploadPriceFilesMakeRequest = useCallback(
        (variables: BimUploadPriceFilesForWorkOrderChangeMutationVariables) => {
            dispatch(request(variables));
        },
        [dispatch, request],
    );

    const bimUploadPriceFilesAbort = useCallback(() => {
        dispatch(abort());
    }, [abort, dispatch]);

    return {
        bimUploadPriceFilesData: data?.bimUploadPriceFilesForWorkOrderChange,
        bimUploadPriceFilesStatus: status,
        bimUploadPriceFilesError: error,
        bimUploadPriceFilesMakeRequest,
        bimUploadPriceFilesReset,
        bimUploadPriceFilesAbort,
    };
};
